export default __webpack_public_path__ + "static/media/750c98ac468036111f16af1f3493496d.png";